var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-page',{attrs:{"title":"亮证"}},[_c('div',{staticClass:"show-cert-page"},[_c('div',{staticClass:"empty-state"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("@/assets/icons/cert-empty.png"),"alt":"没有证照"}}),_vm._v(" "),_c('div',{staticClass:"empty-text"},[_vm._v("没有证照")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a97e352","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ShowCert.vue
// module id = null
// module chunks = 